import { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "./supabaseClient.js";

const AuthContext = createContext({
  user: null,
  loading: false,
  configured: false,
  signIn: async () => ({ error: "Backend non configuré." }),
  signUp: async () => ({ error: "Backend non configuré." }),
  resetPassword: async () => ({ error: "Backend non configuré." }),
  signOut: async () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(!!supabase);

  useEffect(() => {
    if (!supabase) return;
    supabase.auth.getSession().then(({ data }) => {
      setUser(data.session?.user ?? null);
      setLoading(false);
    });
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });
    return () => sub.subscription.unsubscribe();
  }, []);

  const signIn = async (email, password) => {
    if (!supabase) return { error: "Backend non configuré (voir SETUP.md)." };
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    return { error: error?.message || null };
  };

  const signUp = async (email, password) => {
    if (!supabase) return { error: "Backend non configuré (voir SETUP.md)." };
    // Confirmation e-mail : renvoyer vers l'origine courante (prod, preview
    // deploy ou localhost) plutôt que la Site URL fixe du projet Supabase.
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: { emailRedirectTo: window.location.origin },
    });
    return { error: error?.message || null };
  };

  const resetPassword = async (email) => {
    if (!supabase) return { error: "Backend non configuré (voir SETUP.md)." };
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin,
    });
    return { error: error?.message || null };
  };

  const signOut = async () => {
    if (!supabase) return;
    await supabase.auth.signOut();
  };

  return (
    <AuthContext.Provider value={{ user, loading, configured: !!supabase, signIn, signUp, resetPassword, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
